// @flow
export const SET_OPTIMIZELY_AB_TEST = 'SET_OPTIMIZELY_AB_TEST';



// WEBPACK FOOTER //
// ./src/store/reducers/optimizelyABTest/actionTypes.js